import { ResourceManager } from "@/components/admin/ResourceManager";

const RATING_OPTIONS = [1, 2, 3, 4, 5].map((n) => ({ value: String(n), label: `${n} bintang` }));

export const AdminTestimonials = () => (
  <ResourceManager
    title="Testimoni"
    description="Kelola testimoni pelanggan."
    queryKey="testimonials"
    endpoint="/testimonials"
    columns={[
      { key: "name", label: "Nama" },
      { key: "city", label: "Kota" },
      { key: "rating", label: "Rating" },
    ]}
    fields={[
      { name: "name", label: "Nama Pelanggan", type: "text" },
      { name: "city", label: "Kota", type: "text" },
      { name: "text", label: "Isi Testimoni", type: "textarea" },
      { name: "rating", label: "Rating", type: "select", options: RATING_OPTIONS },
      { name: "position", label: "Urutan Tampil", type: "number" },
    ]}
  />
);
